module.exports = {
      id: "highlights-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#highlights",
      toString: function () {
        return this.url;
      }
    }